import React, { Component } from 'react';
import 'leaflet/dist/leaflet.css';
import {observer} from 'mobx-react';
import { withRouter } from 'react-router-dom';

import VandAMap from './VandAMap';
import MapLevels from '../map_levels/MapLevels';
import MapTools from '../map_tools/MapTools';

@withRouter
@observer
class VandAMapContainer extends Component {


  // Add a class to the body if the user is using the mouse, or remove if they're not.
  componentWillMount() {

    document.body.addEventListener('mousedown', function() {
      document.body.classList.add('using-mouse');
    });

    document.body.addEventListener('keydown', () => {
      document.body.classList.remove('using-mouse');
    });
  }

  render() {
    return (
      <React.Fragment>
        <div className="m-home-bar"><a href="https://www.vam.ac.uk/">The V&A</a></div>
        <VandAMap />
        <MapLevels />
        <MapTools />
      </React.Fragment>
    )
  }
}

export default VandAMapContainer;
